import { BaseWebComponentDataProvider } from '../../../../../framework/BaseWebComponentDataProvider';
import {
  GetExtendSeatsPriceFunction,
  GetExtendSeatsUrlFunction,
  GetPlansAndPurchaseDataResponse,
  GetRenewalUrlFunction,
} from '../types/types';

export abstract class PlansAndPurchaseTabBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getPlansAndPurchaseData(): Promise<GetPlansAndPurchaseDataResponse>;

  public abstract getExtendSeatsPrice(
    ...args: Parameters<GetExtendSeatsPriceFunction>
  ): ReturnType<GetExtendSeatsPriceFunction>;

  public abstract getExtendSeatsUrl(
    ...args: Parameters<GetExtendSeatsUrlFunction>
  ): ReturnType<GetExtendSeatsUrlFunction>;

  public abstract getRenewalUrl(...args: Parameters<GetRenewalUrlFunction>): ReturnType<GetRenewalUrlFunction>;
}
